import { useEffect, useRef } from "react";
import Hero from "../sections/Hero";
import Marquee from "../sections/Marquee";
import WhoThisIsFor from "../sections/WhoThisIsFor";
import FeaturedProduct from "../sections/FeaturedProduct";
import Testimonials from "../sections/Testimonials";
import EmailCapture from "../sections/EmailCapture";
import FounderStory from "../sections/FounderStory";
import Affiliate from "../sections/Affiliate";
import Footer from "../sections/Footer";
import Nav from "../sections/Nav";

export default function Home() {
  const ref = useRef(null);
  useEffect(() => {
    document.title = "Findaura Ventures — The future is automated & fabulous";
  }, []);

  return (
    <main ref={ref} data-testid="home-page" className="relative">
      <Nav />
      <Hero />
      <Marquee />
      <WhoThisIsFor />
      <FeaturedProduct />
      <Testimonials />
      <EmailCapture />
      <FounderStory />
      <Affiliate />
      <Footer />
    </main>
  );
}
